import React from "react"
import { Trans, useTranslation } from "react-i18next"
import { connect } from "react-redux"
import { getRoute } from "../helpers/routing"
import { requestLogin } from "../state/modules/login"
import Divider from "./Divider"
import EmailInput from "./EmailInput"
import ErrorDisplay from "./ErrorDisplay"
import FormGroup from "./FormGroup"
import PageForm from "./PageForm"
import Paragraph from "./Paragraph"
import PasswordFormGroup from "./PasswordFormGroup"
import SocialLoginForm from "./SocialLoginForm"
import { TxlGhostButton } from "./TxlButton"
import { TxlLink } from "./TxlLink"

const ID_EMAIL = "user_login_email"
const ID_PASSWORD = "user_login_password"

const LoginPageContent = ({ login, hasAuthFailed }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation("generic")

  return (
    <div>
      <SocialLoginForm />
      <form>
        <FormGroup>
          <PageForm>
            <FormGroup>
              <label htmlFor={ID_EMAIL} id={`label_${ID_EMAIL}`}>
                {t("##.Auth.EmailAddressOrUsername")}
              </label>
              <EmailInput id={ID_EMAIL} />
            </FormGroup>
            <PasswordFormGroup
              id={ID_PASSWORD}
              label={t("##.Auth.Password")}
              passwordType="current"
            />
          </PageForm>
        </FormGroup>
        <FormGroup>
          {hasAuthFailed && (
            <ErrorDisplay>{t("##.Auth.FailedLogin")}</ErrorDisplay>
          )}
          <TxlGhostButton display="block" onClick={login}>
            {t("##.Auth.SignIn")}
          </TxlGhostButton>
        </FormGroup>
        <FormGroup>
          <Trans t={t} i18nKey="##.Auth.ForgotUsernameOrPassword">
            Forgot your
            <TxlLink to={getRoute("/reset-password", language)}>
              username or password?
            </TxlLink>
          </Trans>
        </FormGroup>
        <Trans t={t} i18nKey="##.Auth.HaveNoAccount">
          You don't have an account?
          <TxlLink to={getRoute("/signup", language)}>Sign up.</TxlLink>
        </Trans>
      </form>
      <Divider />
      <Paragraph>
        <Trans t={t} i18nKey="##.Auth.SocialLoginLegalExplanation">
          If you click on 'Sign in with Facebook/Google/LinkedIn' and are not
          yet a TransferXL user, you sign up and agree to TransferXL's
          <TxlLink to={getRoute("/legal/terms", language)}>
            Terms of Use
          </TxlLink>
          and
          <TxlLink to={getRoute("/legal/privacy", language)}>
            Privacy Policy
          </TxlLink>
          .
        </Trans>
      </Paragraph>
    </div>
  )
}

const mapStateToProps = state => {
  return {
    hasAuthFailed: state.login.hasAuthFailed,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    login: evt => {
      evt.preventDefault()
      const username = document.getElementById(ID_EMAIL).value
      const password = document.getElementById(ID_PASSWORD).value
      dispatch(requestLogin(username, password))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginPageContent)
